import { RouteConfig } from "vue-router";
// TO DO: DEV-1682_Refactoring-document-vuex-module
// import { RTemplateDocumentsTemplate } from "@/modules/Services/Template/views/Documents/components/Template/RTemplateDocumentsTemplate";
import { RDocument } from "@/components/DocumentViewCards/RDocument";
import {
  RCandidateTemplateDocumentsBrowse,
  RExpertTemplateDocumentsBrowse,
} from "@/modules/Services/Template/views/Documents/components/Browse/RTemplateDocumentsBrowse";
import { RUploadDocuments } from "@/modules/Documents/Upload/RUploadDocuments";

export const RExpertTemplateDocuments: RouteConfig = {
  path: "documents/:tabTypeId(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "expert-template-documents" */
      "./VTemplateDocuments.vue"
    ),
  meta: {
    label: "documents",
    tabName: "documents",
  },
  children: [RExpertTemplateDocumentsBrowse, RDocument, RUploadDocuments],
};

export const RCandidateTemplateDocuments: RouteConfig = {
  path: "documents/:tabTypeId(\\d+)",
  component: () =>
    import(
      /* webpackChunkName: "candidate-template-documents" */
      "./VTemplateDocuments.vue"
    ),
  meta: {
    label: "documents",
    tabName: "documents",
  },
  children: [RCandidateTemplateDocumentsBrowse, RDocument, RUploadDocuments],
};
